import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MegaMenu.css";

/**
 * Generic Mega Menu dropdown.
 * Props:
 *   items   — array of { id, title, subtitle, image, category }
 *   basePath— "/services" or "/projects"
 *   columns — number of CSS grid columns (default 3)
 *   heading — label shown at top
 *   onClose — callback to close menu
 */
function MegaMenu({ items = [], basePath, columns = 3, heading, onClose }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const go = (id) => {
    navigate(`${basePath}/${id}`);
    onClose && onClose();
  };

  return (
    <div className="mega-menu" style={{ "--cols": columns }}>
      {heading && <p className="mega-menu__heading">{heading}</p>}
      <div className="mega-menu__grid">
        {items.map((item) => {
          const type = basePath === "/services" ? "services_data" : "projects_data";
          const subKey = basePath === "/services" ? "subtitle" : "category";
          
          return (
            <div key={item.id} className="mega-menu__item" onClick={() => go(item.id)}>
              <img
                src={item.image}
                alt={t(`${type}.${item.id}.title`, item.title)}
                className="mega-menu__thumb"
              />
              <div>
                <p className="mega-menu__item-title">{t(`${type}.${item.id}.title`, item.title)}</p>
                <p className="mega-menu__item-sub">{t(`${type}.${item.id}.${subKey}`, item.subtitle || item.category)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MegaMenu;
